var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "col-12 lg-gutter anim-fade md:col-6",
      on: {
        click: function($event) {
          $event.preventDefault()
          return _vm.$emit("click", _vm.place)
        }
      }
    },
    [
      _c("div", { staticClass: "mb-8 text-center cursor-pointer md:mb-16" }, [
        _c("div", { staticClass: "overflow-hidden guide-svg" }, [
          _vm.place.attributes.cover_picture_url
            ? _c("img", {
                staticClass: "img-cover img-zoom h-100",
                attrs: { src: _vm.place.attributes.cover_picture_url }
              })
            : _c(
                "div",
                {
                  staticClass: "flex items-center justify-center h-100",
                  style: _vm.randomBackgroundColor
                },
                [_vm._t("placeholder")],
                2
              )
        ]),
        _c("div", { staticClass: "p-5 thumb-bordered--secondary" }, [
          _c(
            "h2",
            {
              staticClass: "h3 font-bold cursor-pointer thumb-bordered__title"
            },
            [_vm._v(_vm._s(_vm.place.attributes.title))]
          ),
          _c("div", {
            staticClass:
              "font-medium leading-13 cursor-pointer thumb-bordered__title",
            domProps: { innerHTML: _vm._s(_vm.place.attributes.description) }
          }),
          _c(
            "h5",
            {
              staticClass:
                "mx-auto link-primary cursor-pointer font-medium text-center mt-2 cursor-pointer link-underline-fill-primary"
            },
            [_vm._v("Lire la suite")]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }